var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPacifiedRoad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 22,
    viewBox: "0 0 13 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 3.99988C8.6 3.99988 9.5 3.09988 9.5 1.99988C9.5 0.899878 8.6 -0.00012207 7.5 -0.00012207C6.4 -0.00012207 5.5 0.899878 5.5 1.99988C5.5 3.09988 6.4 3.99988 7.5 3.99988ZM3.8 7.39988L1 21.4999H3.1L4.9 13.4999L7 15.4999V21.4999H9V13.9999L6.9 11.9999L7.5 8.99988C8.8 10.4999 10.8 11.4999 13 11.4999V9.49988C11.1 9.49988 9.5 8.49988 8.7 7.09988L7.7 5.49988C7.3 4.89988 6.7 4.49988 6 4.49988C5.7 4.49988 5.5 4.59988 5.2 4.59988L0 6.79988V11.4999H2V8.09988L3.8 7.39988Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPacifiedRoad);
export default __webpack_public_path__ + "static/media/pacifiedRoad.70950020.svg";
export { ForwardRef as ReactComponent };